"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * An adornment, is a element put in a TextField.
 * This one indicate some information about a field
 */
function InfoAdornment(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    tooltip: props.text,
    flow: props.flow,
    className: props.error ? 'error' : '',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
      icon: "info"
    })
  });
}

InfoAdornment.defaultProps = {
  flow: 'left',
  error: false,
  tooltip: ''
};
InfoAdornment.propTypes = {
  text: _propTypes.default.string,
  flow: _propTypes.default.string,
  error: _propTypes.default.bool
};
var _default = InfoAdornment;
exports.default = _default;
//# sourceMappingURL=InfoAdornment.js.map